module.exports = __webpack_public_path__ + "static/balloons-b24d715702484105a2955046254fe925.jpg";